import axiosInstance from "../../../api/axiosConfig";

export const getPersonalizedUsers = (params: any) => {
  return axiosInstance.get("/admin/personalized-users", {
    params: params,
  });
};

export const getUsers = (params: any) => {
  return axiosInstance.get(`/admin/users`, {
    params: {
      ...params,
      userType: "Buyer",
    },
  });
};

export const getProductsByUuid = (uuid: string) => {
  return axiosInstance.get(`/admin/personalized-users/${uuid}/products`);
};

export const deletePersonalizedUser = (uuid: string) => {
  return axiosInstance.delete(`/admin/personalized-users/${uuid}`);
};
